import { render, staticRenderFns } from "./MultiPointOutcomeInput.vue?vue&type=template&id=49362492&scoped=true&"
import script from "./MultiPointOutcomeInput.vue?vue&type=script&lang=ts&"
export * from "./MultiPointOutcomeInput.vue?vue&type=script&lang=ts&"
import style0 from "./MultiPointOutcomeInput.vue?vue&type=style&index=0&id=49362492&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49362492",
  null
  
)

export default component.exports